/**
 * Popper strategy so portfolio Actions dropdowns are not clipped by Bootstrap
 * .table-responsive (overflow). Prefer this over padding hacks on the table wrapper.
 *
 * With `strategy: 'fixed'`, the first paint can misplace the menu (e.g. top-left) until
 * layout settles. One deferred `update()` after the first write fixes that. We key off the
 * Popper instance (WeakSet) so `modifiersData` resets between cycles don't re-trigger loops.
 */
const portfolioDropdownFixedDidDefer = new WeakSet();

export const portfolioTableDropdownPopperConfig = {
  strategy: 'fixed',
  modifiers: [
    {
      name: 'portfolioDropdownFixedLayoutFix',
      enabled: true,
      phase: 'afterWrite',
      fn: ({ state, instance }) => {
        if (portfolioDropdownFixedDidDefer.has(instance)) {
          return state;
        }
        portfolioDropdownFixedDidDefer.add(instance);
        requestAnimationFrame(() => {
          void instance.update();
        });
        return state;
      },
    },
  ],
};
